import { render, staticRenderFns } from "./draggableComponent.vue?vue&type=template&id=168d84b4&scoped=true"
import script from "./draggableComponent.vue?vue&type=script&lang=js"
export * from "./draggableComponent.vue?vue&type=script&lang=js"
import style0 from "./draggableComponent.vue?vue&type=style&index=0&id=168d84b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168d84b4",
  null
  
)

export default component.exports